import { DEFAULT_CURRENCY } from '../../AppShell/app-shell.types';

import { YotpoWidgetProps } from './types';

export function buildYotpoAttributes<T extends Record<string, unknown>>(props: T, prefix = 'data-yotpo-') {
    const attributeMap: Record<string, keyof T> = {
        'image-url': 'imageUrl',
        'instance-id': 'instanceId',
        'product-id': 'productId',
        currency: 'currency',
        description: 'description',
        name: 'name',
        price: 'price',
        url: 'url',
    };

    const attributes: Record<string, unknown> = {};

    Object.entries(attributeMap).forEach(([attributeName, propName]) => {
        const value = props[propName];

        if (value !== undefined && value !== null) {
            attributes[`${prefix}${attributeName}`] = value;
        }
    });

    return attributes;
}

export function getYotpoWidgetAttributes(props: YotpoWidgetProps) {
    const { instanceId, price, product } = props;

    const imageUrl = product?.media_entries?.[0]?.large_url ?? product?.small_image;

    return buildYotpoAttributes({
        currency: DEFAULT_CURRENCY,
        description: product?.description,
        imageUrl,
        instanceId: instanceId,
        name: product?.name,
        price: price?.minimum_price,
        productId: product?.id,
        url: product?.url_key,
    });
}

export default getYotpoWidgetAttributes;
